import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { Router, ActivatedRoute } from '@angular/router';
import { InsuranceGenericEntityDto } from '../../../service/dto';
import { HttpInsurancePremiumRecipientService } from '../../../service/http-insurance-premium-recipient.service';

@Component({
	selector: 'app-dynamic-generic-entity-list',
	standalone: false,
	templateUrl: './dynamic-generic-entity-list.component.html',
	styleUrl: './dynamic-generic-entity-list.component.scss'
})
export class DynamicGenericEntityListComponent implements OnInit, OnDestroy {
	subscription = new Subscription();
	type!: string;
	name!: string;
	data: InsuranceGenericEntityDto[] = [];

	constructor(private httpService: HttpInsurancePremiumRecipientService, private router: Router, private activatedRoute: ActivatedRoute) {

	}
	ngOnInit(): void {
		this.subscription.add(this.activatedRoute.paramMap.subscribe(paramMap => {
			this.type = paramMap.get('type')!;
			this.name = this.getName(this.type);
			this.httpService.getAll(this.type).subscribe(result => {
				this.data = result;
			});
		}));
	}
	ngOnDestroy(): void {
		this.subscription.unsubscribe();
	}

	doView(input: InsuranceGenericEntityDto) {
		this.router.navigate(['/insurance', 'commission', this.type, input.id, 'view']);
	}
	getName(type: string) {
		return type
			.split('_')
			.map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
			.join(' ');
	}
}
